import React, { useContext, useMemo } from 'react'
import { useTranslations } from 'next-intl'
import { Heading, Paragraph } from '../../atoms/Typography/Typography.component'
import { Row, Col, SpacerBase } from '../../atoms/GridSystem'
import Textarea from '../../atoms/Fields/Textarea/Textarea.component'
import Checkbox from '../../atoms/Fields/Checkbox/Checkbox.component'
import * as S from './LeadForm.styles'
import { SectionThemeContext } from '../../../contexts/SectionTheme.context'
import Select from '../../atoms/Fields/Select/Select.component'

type LeadFormStep3Props = {
  withBackground?: boolean
}

function LeadFormStep3({ withBackground }: LeadFormStep3Props) {
  const t = useTranslations('leadForm.step3')
  const tForm = useTranslations('composableForm')
  const { selectedColorScheme } = useContext(SectionThemeContext)

  const existingCustomerOptions = useMemo(() => [
    { label: t('existingCustomerOptions.yes'), value: 'yes' },
    { label: t('existingCustomerOptions.no'), value: 'no' },
  ], [t])

  return (
    <>
      <S.LeadFormStepTitleWrapper colorScheme={selectedColorScheme}>
        <Heading typo="headingXXL" as="h2" content={t('title')} />
        <Paragraph typo="paragraphMD" content={t('description')} />
      </S.LeadFormStepTitleWrapper>

      <Row>
        <Col xs={12} lg={6}>
          <S.FieldWrapper>
            <Textarea
              name="interestedIn"
              id="interestedIn"
              label={t('interestedInLabel')}
              placeholder={t('interestedInPlaceholder')}
              withBackground={withBackground}
            />
          </S.FieldWrapper>
        </Col>
        <Col xs={12} lg={6}>
          <S.FieldWrapper>
            <Select
              name="existingCustomer"
              id="existingCustomer"
              label={t('existingCustomerLabel')}
              options={existingCustomerOptions}
              required
              withBackground={withBackground}
            />
          </S.FieldWrapper>
        </Col>
      </Row>

      <SpacerBase xs={1} />

      <Checkbox
        name="privacy"
        id="privacy"
        label={tForm('privacyLabel')}
        required
        aria-required={true}
        withBackground={withBackground}
      />
    </>
  )
}

export default LeadFormStep3
